module.exports = __webpack_public_path__ + "static/img/equ2.b7d1060d.png";